import { render } from "./VxList.vue?vue&type=template&id=2ad358b8"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"

import "./VxList.vue?vue&type=style&index=0&id=2ad358b8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__